export default (() => {
    class ShippingRule {
        constructor(rule) {
            this.id = Math.random().toString(36).substr(2, 9)
            this.title = ''
            this.couriers = []
            this.deliveryOptions = ['delivery_domestic', 'delivery_eu', 'delivery_non_eu']

            this.service = 'cheapest'
            this.byPriceDelivery = {}
            this.byValueProduct = {}
            this.byParcelValue = {}

            this.insuranceAlways = true
            this.insuranceDetail = {
                couriers: [],
                deliveryType: [],
                deliveryServiceType: []
            }

            this.products = []
            this.priority = 1

            if (rule) {
                Object.assign(this, rule)
            } else {
                this.setQuantityFields('byPriceDelivery', 'between', 2)
                this.setQuantityFields('byValueProduct', 'between', 2)
                this.setQuantityFields('byParcelValue', 'between', 2)
            }
        }
        setQuantityFields(field, key, quantity) {
            this[field] = {}
            this[field][key] = []
            for (let i = 0; i < quantity; i++) {
                this[field][key].push(0)
            }
            return this[field]
        }
    }
    return ShippingRule
})()



// WEBPACK FOOTER //
// ./src/components/UserPanel/Elements/ShippingPolicySettings/services/ShippingRule.js